import { createInstantSearchNextInstance } from 'react-instantsearch-nextjs';

/**
 * Shared InstantSearchNext instance for category pages.
 *
 * Using a single shared instance across all category page renders prevents
 * Cumulative Layout Shift (CLS) when navigating between categories via
 * Next.js Link components, because InstantSearchNext can reuse the existing
 * UI state instead of re-mounting from scratch.
 *
 * @see https://www.algolia.com/doc/guides/building-search-ui/going-further/server-side-rendering/react/#dynamic-routes
 */
const categoryPageAlgoliaInstance = createInstantSearchNextInstance();

export default categoryPageAlgoliaInstance;
